import http from '../../../../../lib/http'
import { notify } from '../../../../../lib/Notification/actions.js'
import { unmapCondition } from '../../../../../lib/Proxy/condition.js'
import { getPatientBanner } from '../../../PatientBanner/actions.js'

export const DIAGNOSES_SUCCESS = 'DIAGNOSES_SUCCESS'
export const DIAGNOSES_FAILURE = 'DIAGNOSES_FAILURE'

export const PAR_FAILURE = 'PAR_FAILURE'
export const UPDATE_PAR = 'UPDATE_PAR'

export const DIAGNOSIS_ISSUE_CHECK = 'DIAGNOSIS_ISSUE_CHECK'
export const DIAGNOSIS_ISSUE_CHECK_FINISHED = 'DIAGNOSIS_ISSUE_CHECK_FINISHED'

export const diagnosisIssueCheck = () => ({
  type: DIAGNOSIS_ISSUE_CHECK
})

export const diagnosisIssueCheckFinished = () => ({
  type: DIAGNOSIS_ISSUE_CHECK_FINISHED
})

function success (data) {
  return {
    type: DIAGNOSES_SUCCESS,
    questionnaireResponse: data
  }
}

function failure (error) {
  return {
    type: DIAGNOSES_FAILURE,
    error
  }
}

export const getDiagnoses = patientId => dispatch =>
  http
    .getRequest(
      `/patients/${patientId}/fhir/Condition?patient=Patient/${patientId}&_count=99999`
    )
    .then(response =>
      Promise.resolve({
        diagnoses: (response.entry || []).map(e =>
          unmapCondition(e.resource || {}))
      }))
    .then(data => dispatch(success(data)))
    .catch(err => dispatch(failure(err)))

function parFailure (error) {
  return {
    type: PAR_FAILURE,
    error
  }
}

function acuity (patient) {
  return {
    type: UPDATE_PAR,
    patient
  }
}

export function updatePatientPar (patientId, patient) {
  return dispatch => {
    dispatch(acuity(patient))
    return http
      .putRequest(`/patients/${patientId}`, patient)
      .then(() => {
        dispatch(notify('Updated Health Program and PAR Successfully'), true)
        dispatch(getPatientBanner())
      })
      .catch(err => dispatch(parFailure(err)))
  }
}
